// extracted by mini-css-extract-plugin
export default {"brandPromo":"vI-z","carousel":"wI-z"};